module.exports = __webpack_public_path__ + "img/hdp-3.f9980a7a.jpeg";